import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,[_c('div',{staticClass:"offline-message"},[_c('span',[_c(VIcon,{attrs:{"color":"white"}},[_vm._v("mdi-close-network")]),_c('br'),_c('div',{staticClass:"mt-6"},[_vm._v(" "+_vm._s(_vm.$t("offline")))]),_c(VBtn,{staticClass:"mt-5",attrs:{"dark":"","text":""},on:{"click":function($event){return _vm.$router.back()}}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-refresh")]),_vm._v(" "+_vm._s(_vm.$t("back"))+" ")],1)],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }